import SimpleBar from 'simplebar';
import $ from 'jquery';
import * as Cookies from 'js-cookie';
import Ajax from '../core/Ajax';

export default class Hero {
	constructor(el, youTubeModule) {
		this.youTubeModule = youTubeModule;
		
		this.el = $(el);
		this.playerWrapper = this.el.find('.hero__player');

		this.brightcovePlayer = videojs.getAllPlayers().length ? videojs.getAllPlayers()[0] : null;

		this.youtubePlayerElement = this.el.find('.hero__ytplayer')[0];
		this.youtubePlayer = null;

		this.videos = {};
		this.relatedVideoIndex = null;
		this.unmuteButton = $('.player__unmute');

		this.nextPopupEl = this.el.get(0).querySelector('.player__next');

		if (this.nextPopupEl) {
			this.nextPopup = {
				image: this.nextPopupEl.querySelector('.player__next-image'),
				title: this.nextPopupEl.querySelector('.player__next-title'),
				counter: this.nextPopupEl.querySelector('.player__next-counter span'),
				cancel: this.nextPopupEl.querySelector('.player__next-cancel'),
			};
		}

		this.placeholder = this.el.get(0).querySelector('.hero__placeholder');
		this.miniPlayerCloseBtn = this.el.get(0).querySelector('.hero__player-close');
		
		this.miniPlayerPaused = false;
		this.miniPlayerClosed = false;

		this.tryToPlay = this.tryToPlay.bind(this);
		this.onLoadedMetaData = this.onLoadedMetaData.bind(this);
		this.onPlay = this.onPlay.bind(this);
		this.onPause = this.onPause.bind(this);
		this.onVolumeChange = this.onVolumeChange.bind(this);
		this.onEnded = this.onEnded.bind(this);
		this.cancelPlayRelatedVideo = this.cancelPlayRelatedVideo.bind(this);
		this.onClickMiniPlayerClose = this.onClickMiniPlayerClose.bind(this);
		this.onClickUnmuteButton = this.onClickUnmuteButton.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.maybeShowUnmuteButton = this.maybeShowUnmuteButton.bind(this);
		this.tabClicks = {};

		// Whether to automatically switch to the next image after X seconds
		this.autoSwitchCounterEnabled = true;
		
		// How often in ms to switch to the next image
		this.autoSwitchInterval = 7000

		if (this.brightcovePlayer) {
			this.initBrightcovePlayer();

			if (this.el.data('type') === 'multi') {
				this.initMulti();
			}

			this.nextPopup.cancel.addEventListener('click', this.cancelPlayRelatedVideo);
			this.unmuteButton.on('click', this.onClickUnmuteButton);
		}

		document.addEventListener('load-category', (data) => {
			new Ajax({
				method: 'GET',
				params: {
					action: 'ajax_load_category_videos',
					category: data.detail.category,
				},
				callback: (ajax) => {
					if (ajax.ok && !ajax.response.error) {
						this.parsePayload(ajax.response);
					} else {
						console.error(ajax.response.error);
					}
				},
			});
		});

		this.initYouTubePlayer(youTubeModule);
	}

	initBrightcovePlayer() {
		this.brightcovePlayer.on('loadedmetadata', this.onLoadedMetaData);
		this.brightcovePlayer.on('play', this.onPlay);
		this.brightcovePlayer.on('pause', this.onPause);
		this.brightcovePlayer.on('volumechange', this.onVolumeChange);
		this.brightcovePlayer.on('ended', this.onEnded);
		this.brightcovePlayer.on('ads-ad-started', this.maybeShowUnmuteButton);
		this.brightcovePlayer.on('ads-ad-ended', this.maybeShowUnmuteButton);
		this.brightcovePlayer.on('ads-ad-skipped', this.maybeShowUnmuteButton);
		this.brightcovePlayer.on('ima3error', this.maybeShowUnmuteButton);
		
		this.el.find('.hero__play').on('click', this.tryToPlay);
		
		this.miniPlayerCloseBtn.addEventListener('click', this.onClickMiniPlayerClose);
		
		$(window).on('scroll touchmove', this.onScroll);
	}

	async initYouTubePlayer(youTubeModule) {
		if (this.youtubePlayerElement && youTubeModule) {
			this.youtubePlayer = await youTubeModule.initYouTubePlayerElement({
				element: this.youtubePlayerElement,
				onReady: ({ event }) => {
					// const isYouTubeTab = this.playerWrapper.hasClass('player--youtube');

					// if (isYouTubeTab) {
					// 	// Auto-play video
					// 	event.target.playVideo();
					// }
				},
				onPlay: this.onPlay,
				onPause: this.onPause,
				onEnded: this.onEnded,
			});
		}		
	}

	parsePayload(response) {
		const parser = new DOMParser();
		const postsHTML = parser.parseFromString(response.posts, 'text/html');
		const posts = postsHTML.querySelectorAll('.hero__tab');

		if (posts.length) {
			this.videos = {};
			this.tabClicks = {};

			const tabsWrapper = this.el.get(0).getElementsByClassName('hero__tabs')[0];
			tabsWrapper.innerHTML = '';

			for (let post of posts) {
				tabsWrapper.appendChild(post);
			}

			this.initMulti();
		}
	}

	tryToPlay() {
		const muted = this.getMutedCookie();

		if (muted == 1) {
			this.brightcovePlayer.muted(true);
		} else if (muted == 0) {
			this.brightcovePlayer.muted(false);
		}
		
		const promise = this.brightcovePlayer.play();

		if (promise !== undefined) {
			promise
				.then(() => {
					this.brightcovePlayer.volume(this.getVolumeCookie());
				})
				.catch((err) => {
					this.brightcovePlayer.muted(true);
					this.brightcovePlayer.play();
				});
		}

		setTimeout(() => this.maybeShowUnmuteButton(), 1000);
	}

	onLoadedMetaData() {
		if (this.getAutoplayCookie() == 1) {
			this.tryToPlay();
		}
	}

	onPlay(e) {
		if (e && e.type === 'youtube') {
			const videoId = e.event.target.getVideoData().video_id;
			
			if (!this.tabClicks[videoId]) {
				this.tabClicks[videoId] = 0;
			}

			this.tabClicks[videoId]++;
		} else {
			if (this.brightcovePlayer.mediainfo) {
				const videoId = this.brightcovePlayer.mediainfo.id;
				
				if (!this.tabClicks[videoId]) {
					this.tabClicks[videoId] = 0;
				}
				
				this.tabClicks[videoId]++;
			}
		}

		this.playerWrapper.addClass('player--started player--playing');
		this.playerWrapper.removeClass('player--ended player--paused');

		setTimeout(() => this.playerWrapper.removeClass('player--loading'), 600);
		
		this.cancelPlayRelatedVideo();

		Cookies.set('vb_autoplay', 1, { expires: 365, path: '/' });
	}

	onPause(e) {
		this.playerWrapper.addClass('player--paused');
		this.playerWrapper.removeClass('player--playing');
		
		Cookies.set('vb_autoplay', 0, { expires: 365, path: '/' });
	}

	onVolumeChange() {
		if (this.brightcovePlayer) {
			Cookies.set('vb_volume', this.brightcovePlayer.volume(), { expires: 365, path: '/' });

			if (this.brightcovePlayer.volume() == 0 || this.brightcovePlayer.muted()) {
				Cookies.set('vb_muted', 1, { expires: 365, path: '/' });
			} else {
				Cookies.set('vb_muted', 0, { expires: 365, path: '/' });
			}
		}

		this.maybeShowUnmuteButton();
	}

	onEnded(e) {
		this.playerWrapper.removeClass('player--playing');
		this.playerWrapper.addClass('player--ended player--paused');

		if (this.relatedVideoIndex === null) {
			this.relatedVideoIndex = 0;
		} else {
			this.relatedVideoIndex++;
		}

		if (this.el.data('type') === 'multi' && window.innerWidth >= 1024) {
			this.nextTab();
		} else if (
			this.el.data('type') === 'single' &&
			relatedVideos[this.relatedVideoIndex]
		) {
			this.startNextVideoCounter(relatedVideos[this.relatedVideoIndex]);
		}
	}

	startNextVideoCounter(video) {
		let seconds = this.autoSwitchInterval / 1000;

		this.nextPopup.image.style.backgroundImage = `url(${video.image})`;
		this.nextPopup.title.innerHTML = video.title;

		this.nextPopup.counter.textContent = seconds;
		this.playerWrapper.addClass('player--transition');
		this.nextPopupEl.classList.add('player__next--visible');

		clearInterval(this.nextCounter);

		this.nextCounter = setInterval(() => {
			seconds--;
			this.nextPopup.counter.textContent = seconds;

			if (seconds == 0) {
				this.playerWrapper.removeClass('player--transition');
				this.nextPopupEl.classList.remove('player__next--visible');
				clearInterval(this.nextCounter);
				this.playRelatedVideo(video);
			}
		}, 1000);
	}

	cancelPlayRelatedVideo() {
		this.playerWrapper.removeClass('player--ended player--transition');
		this.nextPopupEl.classList.remove('player__next--visible');
		clearInterval(this.nextCounter);
	}

	playRelatedVideo(video) {
		this.el.find('.hero__content').prop('href', video.k);
		this.el.find('.hero__content-category').html(video.category);
		this.el.find('.hero__content-title').html(video.title);

		$('.item').removeClass('item--playing');
		$(`.item[data-post-id="${video.postId}"]`).addClass('item--playing');

		this.brightcovePlayer.catalog.getVideo(
			relatedVideos[this.relatedVideoIndex].videoId,
			(error, video) => {
				this.brightcovePlayer.catalog.load(video);
				this.tryToPlay();
			}
		);
	}

	maybeShowUnmuteButton() {
		if (
			(this.brightcovePlayer.volume() == 0 || this.brightcovePlayer.muted()) && this.brightcovePlayer.ima3 &&
			(!this.brightcovePlayer.ima3.adPlayer || this.brightcovePlayer.ima3.adPlayer.paused())
		) {
			this.unmuteButton.addClass('player__unmute--visible');
		} else {
			this.unmuteButton.removeClass('player__unmute--visible');
		}
	}

	onClickUnmuteButton() {
		this.brightcovePlayer.muted(false);
		this.brightcovePlayer.volume(Math.max(0.5, this.getVolumeCookie()));
	}

	getMutedCookie() {
		const muted = Cookies.get('vb_muted');
		if (muted === undefined) {
			return 0;
		}

		return muted;
	}

	getVolumeCookie() {
		const volume = Cookies.get('vb_volume');

		if (volume === undefined) {
			return 0.5;
		}

		return volume;
	}

	getAutoplayCookie() {
		const autoplay = Cookies.get('vb_autoplay');

		if (autoplay === undefined) {
			return 1;
		}

		return autoplay;
	}

	initMulti() {
		this.tabsWrapper = this.el.get(0).querySelector('.hero__tabs');
		this.tabs = this.tabsWrapper.querySelectorAll('.hero__tab');

		if (this.tabs.length > 3) {
			this.tabsScrollbar = new SimpleBar(this.tabsWrapper);
		}

		for (let tab of this.tabs) {
			this.bindClickTab(tab);
		}

		if (this.tabs.length && window.innerWidth > 1023) {
			this.selectVideoTab(this.tabs[0]);
		}

		setTimeout(() => {
			for (let tab of this.tabs) {
				if (tab.dataset.videoId) {
					this.brightcovePlayer.catalog.getVideo(tab.dataset.videoId, (error, video) => {
						this.videos[tab.dataset.videoId] = video;
					});
				}
			}
		}, 1000);
	}

	bindClickTab(tab) {
		tab.addEventListener('click', (e) => {
			const isActiveTab = tab.classList.contains('hero__tab--active');
			const isVideoTab = tab.classList.contains('hero__tab--video');
			const isLinkTab = tab.classList.contains('hero__tab--link');

			if (!isActiveTab && isLinkTab) {
				const isUserClick = (e.pointerType === 'mouse' || e.pointerType === 'touch');

				// Go to link directly if user clicked on a non-video tab
				if (isUserClick && !isVideoTab) {
					return;
				}

				// Prevent from going to link
				e.preventDefault();
			}

			// Select tab
			this.selectVideoTab(tab);
		});
	}

	selectVideoTab(tab) {
		const postId = tab.dataset.postId;
		const type = tab.dataset.youtubeVideoId ? 'youtube' : 'brightcove';
		const videoId = tab.dataset.youtubeVideoId ? tab.dataset.youtubeVideoId : tab.dataset.videoId;

		if (!this.tabClicks[postId]) {
			this.tabClicks[postId] = 0;
		}

		if (!this.tabClicks[videoId]) {
			this.tabClicks[videoId] = 0;
		}

		const isTabletOrBelow = window.innerWidth <= 1023;

		// Check if post/video tab was clicked before
		if (
			this.tabClicks[postId] || this.tabClicks[videoId] || isTabletOrBelow
		) {
			// Go to post/video permalink if the tab was clicked bnefore
			window.location.href = tab.dataset.permalink;

			return;
		}

		if (!this.tabClicks[postId] && !videoId) {
			this.startTabSwitchCounter(tab);
		}

		for (let tab of this.tabs) {
			tab.classList.remove('hero__tab--active');
		}

		tab.classList.add('hero__tab--active');

		// Show/hide Brightcove vs YouTube depending on which video type is selected
		if (type === 'brightcove') {
			this.playerWrapper.addClass('player--brightcove');
			this.playerWrapper.removeClass('player--youtube');
		} else if (type === 'youtube') {
			this.playerWrapper.addClass('player--youtube');
			this.playerWrapper.removeClass('player--brightcove');
		}

		this.playerWrapper.removeClass('player--loading');
		this.playerWrapper.data('tab', tab.dataset.index);
		
		cancelAnimationFrame(this.tabSwitchAnimationFrame);

		const $tabImage = tab.querySelector('.hero__tab-image img');
		const imageSrc = $tabImage ? $tabImage.src : null;

		if (imageSrc) {
			const heroImageElement = this.el.find('.hero__image');
			
			if (heroImageElement) {
				heroImageElement.css('background-image', `url(${imageSrc})`);
			} else {
				console.warn('Could not find hero image element');
			}
		}

		const title = tab.querySelector('.hero__tab-title').textContent;
		const $heroImageTitleElement = this.el.find('.hero__image-title-link');
		
		if ($heroImageTitleElement && $heroImageTitleElement[0]) {
			$heroImageTitleElement[0].innerHTML = title;
		}

		if (this.brightcovePlayer) {
			this.brightcovePlayer.pause();
		}

		if (this.youtubePlayer) {
			this.youtubePlayer.pauseVideo();
		}

		Cookies.set('vb_autoplay', 1, { expires: 365, path: '/' });

		this.playerWrapper.removeClass('player--started');

		if (tab.dataset.youtubeVideoId) {
			const loadAndPlayYouTubeVideo = (youtubeId) => {
				this.youtubePlayer.loadVideoById(youtubeId);
			};

			const loadYouTubeVideo = (youtubeId) => {
				this.youtubePlayer.cueVideoById(youtubeId);
			};

			if (this.youtubePlayer) {
				loadYouTubeVideo(tab.dataset.youtubeVideoId);
			} else {
				this.waitForYouTubePlayerReady({ onReady: () => loadYouTubeVideo(tab.dataset.youtubeVideoId) });
			}
		} else if (tab.dataset.videoId) {
			this.playerWrapper.addClass('player--loading');
			this.playerWrapper.removeClass('player--novid');

			if (this.videos[tab.dataset.videoId]) {
				this.brightcovePlayer.catalog.load(this.videos[tab.dataset.videoId]);
				this.tryToPlay();
			} else {
				this.brightcovePlayer.catalog.getVideo(
					tab.dataset.videoId,
					(error, video) => {
						this.brightcovePlayer.catalog.load(video);
						this.videos[tab.dataset.videoId] = video;
						this.tryToPlay();
					}
				);
			}
		} else {
			this.playerWrapper.addClass('player--novid');

			if (this.autoSwitchCounterEnabled && window.innerWidth >= 1024) {
				this.startTabSwitchCounter(tab);
			}
		}

		if (!videoId) {
			this.tabClicks[postId]++;
		}
	}

	waitForYouTubePlayerReady({ onReady }) {
        if (this.youtubePlayer) {
            onReady();
        } else {
            let waitInterval = setInterval(() => {
                if (this.youtubePlayer) {
                    clearInterval(waitInterval);

                    onReady();
                }
            }, 250);
        }
    }

	startTabSwitchCounter(tab) {
		cancelAnimationFrame(this.tabSwitchAnimationFrame);

		const lastTab = this.isLastTab();

		if (!lastTab) {
			const bar = tab.querySelector('.hero__tab-bar');
			let time = 0;
			let initTime = false;

			const countdown = (timestamp) => {
				if (initTime === false) {
					initTime = timestamp;
				}

				time = timestamp - initTime;
				bar.style.width = `${(1 - time / this.autoSwitchInterval) * 100}%`;

				if (time >= this.autoSwitchInterval) {
					cancelAnimationFrame(this.tabSwitchAnimationFrame);
					this.nextTab();
				} else {
					this.tabSwitchAnimationFrame = requestAnimationFrame(countdown);
				}
			};

			this.tabSwitchAnimationFrame = requestAnimationFrame(countdown);
		}
	}

	nextTab() {
		for (let i = 0; i < this.tabs.length; i++) {
			if (
				this.tabs[i].classList.contains('hero__tab--active') &&
				this.tabs[i + 1]
			) {
				this.tabs[i + 1].click();
				break;
			}
		}
	}

	isLastTab() {
		for (let i = 0; i < this.tabs.length; i++) {
			if (this.tabs[i].classList.contains('hero__tab--active')) {
				if (i + 1 == this.tabs.length) {
					return true;
				} else {
					return false;
				}
			}
		}

		return false;
	}

	onScroll(e) {
		let breakpoint =
			this.placeholder.getBoundingClientRect().top +
			this.placeholder.offsetHeight;

		if (document.body.classList.contains('admin-bar')) {
			breakpoint -= 32;

			if (window.innerWidth <= 782) {
				breakpoint -= 14;
			}
		}

		if (
			!this.miniPlayerClosed &&
			breakpoint <= 0 &&
			this.brightcovePlayer &&
			!this.brightcovePlayer.paused() &&
			['medium', 'large', 'infinity'].includes(this.brightcovePlayer.currentBreakpoint())
		) {
			document.body.classList.add('mini-player');
		} else {
			document.body.classList.remove('mini-player');
		}
	}

	onPlayerPause(e) {
		this.miniPlayerPaused = document.body.classList.contains('mini-player');
	}

	onClickMiniPlayerClose(e) {
		this.miniPlayerClosed = true;

		document.body.classList.remove('mini-player');
	}
}
